module.exports = __webpack_public_path__ + "img/logo (copy).f2db906e.png";